export var decorateWith = function decorateWith() {
  for (var _len = arguments.length, decorators = new Array(_len), _key = 0; _key < _len; _key++) {
    decorators[_key] = arguments[_key];
  }

  return function (unwrapped) {
    return decorators.reduce(function (component, decorator) {
      return decorator(component);
    }, unwrapped);
  };
};
export function withName(displayName) {
  return function (Component) {
    Component.displayName = displayName;
    return Component;
  };
}